import { Controller } from "./modules/controller";
import { mountOn } from "./helpers/mount";

class App extends Controller {
	constructor() {
		super({ ready: true, loaded: true });
	}

	init() {
		this.initCritical();
		this.initImportant();
		this.defer(() => this.initLazy());
	}
	initCritical() {

		mountOn('[data-menu]', async () => {
			const { Menu } = await import("./modules/menu");
			new Menu();
		});

		mountOn('.header', async (nodes) => {
			const { Header } = await import("./modules/header");
			new Header(nodes[0]);
		});
	}
	initImportant() {

		mountOn('[data-accordion]', async (nodes) => {
			const { Accordion } = await import("./modules/accordion-toggle");
			new Accordion(nodes[0]);
		});

		mountOn('.product-form', async (node) => {
			const { Form } = await import("./woocommerce/form");
			new Form(node[0], this.cropModal);
		});

		mountOn('[data-component="db-manager"]', async (nodes) => {
			const { DbManager } = await import("./modules/db-manager");
			nodes.forEach((node) => new DbManager(node));
		});
	}
	initLazy() {
		mountOn('[data-show-more]', async (nodes) => {
			const { ShowMore } = await import("./modules/show-more");
			nodes.forEach(() => new ShowMore());
		});

		mountOn('.js-slider', async (nodes) => {
			const { Slider } = await import("./modules/slider");
			nodes.forEach(() => new Slider());
		}, { visibleOnly: true });

		mountOn('[data-component="reminder-modal"]', async (nodes) => {
			const { Modal } = await import("./modules/modal");
			if (!window.Modal) {
				window.Modal = Modal;
			}
			nodes.forEach((node) => new Modal(node));
		});

		mountOn('[data-component="cart-modal"]', async (nodes) => {
			const { Modal } = await import("./modules/modal");
			if (!window.Modal) {
				window.Modal = Modal;
			}
			nodes.forEach((node) => new Modal(node));
		});

		mountOn('[data-component="rutube-modal"]', async (nodes) => {
			const { RutubeModal } = await import("./modules/rutube-modal");
			nodes.forEach((node) => new RutubeModal(node));
		});

        mountOn('[data-download-image]', async (nodes) => {
            const { DownloadImage } = await import("./modules/download-image");
            nodes.forEach(node => new DownloadImage(node));
        })
	}
	
	defer(fn) {
		if ('requestIdleCallback' in window) {
			requestIdleCallback(fn, { timeout: 2000 });
		} else {
			setTimeout(fn, 500);
		}
	}
	ready() { /* ... */ }
	loaded() { /* ... */ }
}

new App();
